export function decode(encodedString: string) {
  if (typeof atob === 'function') {
    try {
      return atob(encodedString)
    } catch {
      return null
    }
  }
  if (IS_SSR) {
    // Buffer only exists in Node; browsers use atob above.
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (Buffer && Buffer.from) {
      return Buffer.from(encodedString, 'base64').toString()
    }
  }
  return null
}

export function encode(string: string) {
  if (typeof btoa === 'function') {
    try {
      return btoa(string)
    } catch {
      return null
    }
  }
  if (IS_SSR) {
    if (Buffer) {
      return Buffer.from(string).toString('base64')
    }
  }
  return null
}

/**
 * Normalizes base64 strings by removing padding characters.
 * Different base64 encoders may produce different padding, so this ensures consistent comparison.
 */
export function normalizeBase64(base64String: string) {
  return base64String.replace(/=+$/, '')
}
